// extracted by mini-css-extract-plugin
export default {"textSourceName":"style_textSourceName__AuNFZ","truncate":"style_truncate__dAT-A"};